const STORAGE_KEY = 'cvgidas_saved_jobs';

export type LocalSavedJob = {
  id: number;
  title: string;
  company_name: string;
  location: string;
  salary_min: number | null;
  salary_max: number | null;
  job_type: string;
  work_time: string;
  created_at: string;
  expires_at: string | null;
  saved_at: string;
};

export function getLocalSavedJobs(): LocalSavedJob[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addLocalSavedJob(job: LocalSavedJob): void {
  try {
    const list = getLocalSavedJobs();
    if (list.some((j) => j.id === job.id)) return;
    list.push(job);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
}

export function removeLocalSavedJob(jobId: number): void {
  try {
    const list = getLocalSavedJobs().filter((j) => j.id !== jobId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch { /* localStorage unavailable */ }
}

export function isJobSavedLocally(jobId: number): boolean {
  try {
    return getLocalSavedJobs().some((j) => j.id === jobId);
  } catch {
    return false;
  }
}

export function clearLocalSavedJobs(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* localStorage unavailable */ }
}
